import store from '@/store';

const appCommonMixin = {
  methods: {
    deepClone(obj) {
      if (typeof obj === 'object') {
        return JSON.parse(JSON.stringify(obj));
      }
      return obj;
    },
    displaySnackBar({ title, content, type }) {
      store.dispatch('appStore/setAppData', {
        message: {
          content,
          type,
          component: 'snackbar',
          title,
          close: true,
          persistent: true,
        },
      });
    },
    displayInFormMessage({ content, type, title }) {
      store.dispatch('appStore/setAppData', {
        message: {
          content,
          type,
          component: 'alert',
          close: true,
          persistent: true,
          title,
          width: '500px',
          messageProperty: true,
        },
      });
    },
    displayPopUp({ content, type, title, status, close = true, saveCallback, cancelCallback, icon, rounded = false, alignCenter, hideToolbar, showDivider, width, saveButton, cancelButton, deletePopup }) {
      store.dispatch('appStore/setAppData', {
        message: {
          content,
          type,
          component: 'modal',
          close: close,
          persistent: true,
          title,
          width: width || '500px',
          messageProperty: true,
          status,
          saveButton: saveButton || 'Delete',
          saveCallback: saveCallback,
          cancelCallback: cancelCallback,
          cancelButton: cancelButton || 'Cancel',
          hideToolbar,
          icon,
          rounded,
          alignCenter,
          showDivider,
          deletePopup,
        },
      });
    },
    getExternalCSS(cssAttributeProperty, defaultCSS = 'white') {
      return this.customCSS[cssAttributeProperty] || defaultCSS;
    },
  },
};

export default appCommonMixin;
